import React from "react";
import "./recharge-history-list.less";
import {
  Button,
  ListView,
  DatePicker,
  PullToRefresh,
  ActivityIndicator,
  Modal,
  Tabs
} from 'antd-mobile'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'
import { rechargeHisApi } from "@/api/sany";
import Cookies from "universal-cookie";
import moment from "moment";
const cookie = new Cookies()
const APullToRefresh: any = PullToRefresh
const Footer = ({ isLoading, isHasMore, noHasMore }: any) => {
  if (!isHasMore) {
    return noHasMore || <div className="text-center" style={{ fontSize: '12px', color: '#b8b5b5' }}>没有更多啦</div>
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}
@(withRouter as any)
export default class RechargeHistoryList extends React.Component<any, any> {
  tabs = [{ title: '个人充值记录' }, { title: '同住人充值记录 ' }]
  lv: any
  dataBlobs: any = {}
  rowIDs: any = []
  isHasMore = false
  pageIndex = 1
  mainDiv!: any

  constructor(prop: any) {
    super(prop)
    this.rowIDs[0] = []
    this.mainDiv = React.createRef()
    const getSectionData = (dataBlob: any, sectionID: any) =>
      dataBlob[sectionID]
    const getRowData = (dataBlob: any, sectionID: any, rowID: any) =>
      dataBlob[rowID]
    // 构造数据
    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1: any, row2: any) => row1 !== row2, // 用其进行数据变更的比较 判断不同item行是否相同
      sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2, // 不同之处，还应判断section是否相同
    })
    this.state = {
      dataSource,
      isLoading: true,
      infoShow: false,
      modalInfo: {},
      height: (document.documentElement.clientHeight * 3) / 4,
      month: '',
      sumList: [],
      tabsIndex: 0,
    }
    // 绑定this ios低版本不兼容箭头函数
    this.getRechageList = this.getRechageList.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.onEndReached = this.onEndReached.bind(this)
    this.getModal = this.getModal.bind(this)
    this.getModallist = this.getModallist.bind(this)
    this.showModal = this.showModal.bind(this)
    this.changeShowMoth = this.changeShowMoth.bind(this)
    this.allList = this.allList.bind(this)
  }
  componentDidMount() {
    const height = document.documentElement.clientHeight - (ReactDOM.findDOMNode(this.mainDiv.current,) as any).getBoundingClientRect().top
    this.setState({ height })
    const hei = document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.lv) as any).getBoundingClientRect().top
    this.setState({
      height: hei,
    })
    // this.getRechageList()
    this.changeShowMoth(new Date())
  }
  // componentWillMount() {
  //   // this.getRechageList()
  // }
  //下拉刷新
  onRefresh() {
    if (this.state.isLoading) {
      return
    }
    this.initData()
    this.setState({ isRefreshing: true, isLoading: true })
    this.getRechageList()
    this.setState({
      isRefreshing: false,
      isLoading: false,
    })
  }
  // 
  initData() {
    this.pageIndex = 1
    this.rowIDs[0] = []
    this.dataBlobs = {}
    this.dataBlobs['section0'] = 'section0'
  }
  //上拉加载更多
  onEndReached(event: any) {
    if (this.state.isLoading || !this.isHasMore) {
      return
    }
    this.pageIndex++
    this.getRechageList()
  }

  //分页请求
  async getRechageList() {
    this.setState({
      isLoading: true,
    })
    const params = {
      store_id: cookie.get('rechargeStoreId'),
      phone: cookie.get('sany_phone'),
      month: this.state.month,
      room_id: this.state.tabsIndex === 0 ? 0 : cookie.get('room_id')
    }
    const { data } = await rechargeHisApi(params)
    // const {data} = await rechargeHisApi({store_id: 159, phone: 15868194226, month:this.state.month})
    this.setState({
      isLoading: false
    })
    if (data.code === 'SUCCESS') {
        data.data.list.forEach((item: any, index: number) => {
          const rowName = item.id
          this.dataBlobs[rowName] = item
          this.rowIDs[0].push(rowName)
        })
  
        const sectionIDs = [0]
        this.rowIDs = [...this.rowIDs]
        // 更新数据
        // debugger
        this.setState({
          sumList: data.data.sum,
          dataSource: this.state.dataSource.cloneWithRowsAndSections(
            this.dataBlobs,
            sectionIDs,
            this.rowIDs,
          ),
        })
    }
  }
  getModal() {
    return (
      <Modal
        visible={this.state.infoShow}
        transparent
        maskClosable={false}
        title=""
        footer={[{ text: '确定', onPress: () => this.onClose()() }]}
      >
        <div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>房间地址：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.store_name}-{this.state.modalInfo.building_no}-{this.state.modalInfo.room_no}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值项目：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.fee_type_name}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>付款方式：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.pay_way_name}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>支付时间：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.pay_at}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>支付金额：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.money}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值时间：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.recharge_at}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值用量：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.usage}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值状态：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.status_name}</div>
          </div>
        </div>
      </Modal>
    )
  }
  getModallist() {
    return (
      <Modal
        visible={this.state.infoShow}
        transparent
        maskClosable={false}
        title=""
        footer={[{ text: '确定', onPress: () => this.onClose()() }]}
      >
        <div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>房间地址：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.store_name}-{this.state.modalInfo.building_no}-{this.state.modalInfo.room_no}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>房间号：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.room_no}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值项目：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.fee_type_name}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>付款方式：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.pay_way_name}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>支付时间：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.pay_at}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>支付金额：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.money}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值时间：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.recharge_at}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值用量：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.usage}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>充值状态：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.status_name}</div>
          </div>
          <div className="lineHeight" style={{ display: 'flex' }}>
            <div style={{ color: '#000', fontWeight: 800, width: '90px' }}>缴费人：</div>
            <div style={{ textAlign: 'left' }}>{this.state.modalInfo.name}</div>
          </div>
        </div>
      </Modal>
    )
  }
  showModal = (val: any) => (e: any) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      modalInfo: val,
      infoShow: true,
    });
  }
  onClose = () => () => {
    this.setState({
      infoShow: false,
    });
  }
  // getShowDate = (value: any) => {
  //   let datValue = moment(value).format('YYYY-MM')
  //   return datValue;
  // }
  allList() {
    this.setState({
      month: '',
    },
      async () => {
        this.rowIDs[0] = []
        await this.getRechageList()
      })
  }
  changeShowMoth(v: any) {
    const month = moment(v).format('YYYY-MM')
    setTimeout(() => {
      this.setState({
        month
      }, () => {
        this.rowIDs[0] = []
        this.getRechageList()
      })
    }, 0)
  }
  tabChange(tab: any, index: number) {
    console.log(index)
      this.setState({
        tabsIndex: index
      }, () => {
        this.initData()
        this.changeShowMoth(new Date())
        // this.getRechageList()
      })
  }
  render() {
    const { isRefreshing, isLoading } = this.state
    const { isHasMore } = this
    const header = (sectionData: any) => {
      return (
        <div className="section-header">
          {sectionData}
        </div>
      )
    }
    const row = (rowData: any, sectionID: any, rowID: any) => {
      let tagIcon = '/public/assets/img/bill_electric.png'
      if (rowData.fee_type === '1') {
        tagIcon = '/public/assets/img/bill_electric.png'
      } else if (rowData.fee_type === '2') {
        tagIcon = '/public/assets/img/bill_cold_water.png'
      } else {
        tagIcon = '/public/assets/img/bill_electric.png'
      }
      return (
        <div className="bill-cell-bg" >
          {/* onClick={this.showModal(rowData)} 点击事件去掉，如果需求需要再次需要加在div里面即可  */}
          <div className="bill-cell">
           <div className="between-row">
              <span style={{ color: '#949494', fontSize: '13px' }}>{rowData.recharge_at}</span>
              {/* <span style={{ color: rowData.status_name ==='充值成功' || rowData.status_name ==='充值中' ? '#167001' : '#c90102' }}>{rowData.status_name}</span> */}
              <span style={{ color: rowData.status_name === '充值成功' ? '#167001' : rowData.status_name === '充值中' ? '#f39800' : '#c90102' }}>{rowData.status_name}</span>
            </div>
            <div className="between-row">
              <div className="img-row">
                <img src={tagIcon} alt="" style={{ width: 24, height: 24 }} />
                <span style={{ paddingLeft: '5px', fontSize: '14px' }}>{rowData.fee_type === '1' ? '电费' : '水费'}</span>
              </div>
              <span style={{ color: '#d5151f', fontSize: '18px' }}>￥{rowData.money}</span>
            </div>
            
          </div>
        </div>
      )
    }

    const rowlist = (rowData: any, sectionID: any, rowID: any) => {
      let tagIcon = '/public/assets/img/bill_electric.png'
      if (rowData.fee_type === '1') {
        tagIcon = '/public/assets/img/bill_electric.png'
      } else if (rowData.fee_type === '2') {
        tagIcon = '/public/assets/img/bill_cold_water.png'
      } else {
        tagIcon = '/public/assets/img/bill_electric.png'
      }
      return (
        <div className="bill-cell-bg">
          {/* onClick={this.showModal(rowData)}  点击事件去掉，如果需求需要再次需要加在div里面即可 */}
          <div className="bill-cell">
            <div className="between-row">
              <span style={{ color: '#949494', fontSize: '13px', paddingLeft: '5px' }}>{rowData.recharge_at}</span>
              {/* <span style={{ color: rowData.status_name ==='充值成功' || rowData.status_name ==='充值中' ? '#167001' : '#c90102' }}>{rowData.status_name}</span> */}
              <span style={{ color: rowData.status_name === '充值成功' ? '#167001' : rowData.status_name === '充值中' ? '#f39800' : '#c90102' }}>{rowData.status_name}</span>
            </div>
            <div className="between-row">
              <div className="img-row">
                <img src={tagIcon} alt="" style={{ width: 24, height: 24 }} />
                <span style={{ paddingLeft: '5px', fontSize: '14px' }}>{rowData.fee_type === '1' ? '电费' : '水费'}</span>
              </div>
              <span style={{ color: '#d5151f', fontSize: '18px' }}>￥{rowData.money}</span>
            </div>
            <div className="room_bottom">
              <div style={{ float: 'left' }}>
                <span style={{ color: '#949494', fontSize: '12px' }}>房间号：{rowData.room_no}</span>
              </div>
              <div style={{ float: 'right' }}>
                <span style={{ color: '#949494', fontSize: '12px' }}>缴费人：{rowData.name}</span>
              </div>
            </div>
          </div>
        </div>
      )
    }
    const month = this.state.month === '' ? '按月筛选' : this.state.month
    return (
      <div>
        <Tabs tabs={this.tabs} initialPage={this.state.tabsIndex} swipeable={false} onChange={(tab: any, index: number) => this.tabChange(tab, index)}>
          <div style={{ height: this.state.height }} ref={this.mainDiv}>
            <div>
              <div className="nav">
                {/* <Button style={{ textAlign: 'left', paddingLeft: '15px' }} onClick={this.allList}>全部</Button> */}
                <DatePicker
                  mode="month"
                  title="选择时间"
                  extra="Optional"
                  onChange={this.changeShowMoth}
                >
                  <div style={{ fontSize: '18px', height: '40px', lineHeight: '40px', paddingLeft: '15px', color:'#1E90FF' }}>{month + ' ▼'}</div>
                </DatePicker>
                <div style={{ padding: '0 0 10px 15px', display: 'flex' }}>
                  {this.state.sumList.map((item: any, index: any) => {
                    return (
                      <div key={index}>
                        <span>{item.fee_type_name}{item.fee_type_name ? '：' : ''}</span><span style={{ marginRight: '15px' }}>{item.money ? '￥' : ''}{item.money}{item.money ? '元' : ''}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
              <ListView
                className="recharge-list"
                ref={(el: any) => (this.lv = el)}
                dataSource={this.state.dataSource}
                renderFooter={() => (
                  <Footer isLoading={isLoading} isHasMore={isHasMore} />
                )}
                renderSectionHeader={header}
                // renderSeparator={separator}
                renderRow={row}
                style={{
                  height: this.state.height,
                  overflow: 'auto',
                }}
                onEndReached={this.onEndReached}
                pullToRefresh={
                  <APullToRefresh
                    refreshing={isRefreshing}
                    onRefresh={this.onRefresh}
                  />
                }
              />
              {this.state.infoShow ? this.getModal() : ''}
            </div>
          </div>

          <div style={{ height: this.state.height }} ref={this.mainDiv}>
            <div>
              <div className="nav">
                {/* <Button style={{ textAlign: 'left', paddingLeft: '15px' }} onClick={this.allList}>全部</Button> */}
                <DatePicker
                  mode="month"
                  title="选择时间"
                  extra="Optional"
                  onChange={this.changeShowMoth}
                >
                  <div style={{ fontSize: '18px', height: '40px', lineHeight: '40px', paddingLeft: '15px',color:'#1E90FF' }}>{month + ' ▼'}</div>
                </DatePicker>
                <div style={{ padding: '0 0 10px 15px', display: 'flex' }}>
                  {this.state.sumList.map((item: any, index: any) => {
                    return (
                      <div key={index}>
                        <span>{item.fee_type_name}{item.fee_type_name ? '：' : ''}</span><span style={{ marginRight: '15px' }}>{item.money ? '￥' : ''}{item.money}{item.money ? '元' : ''}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
              <ListView
                className="recharge-list"
                ref={(el: any) => (this.lv = el)}
                dataSource={this.state.dataSource}
                renderFooter={() => (
                  <Footer isLoading={isLoading} isHasMore={isHasMore} />
                )}
                renderSectionHeader={header}
                // renderSeparator={separator}
                renderRow={rowlist}
                style={{
                  height: this.state.height,
                  overflow: 'auto',
                }}
                onEndReached={this.onEndReached}
                pullToRefresh={
                  <APullToRefresh
                    refreshing={isRefreshing}
                    onRefresh={this.onRefresh}
                  />
                }
              />
              {this.state.infoShow ? this.getModallist() : ''}
            </div>
          </div>
        </Tabs>
      </div >
    )
  }
}
